<template>
  <div>
    <b-form-group
      :label="$t('workflow.processDisplayName')"
      label-for="input-process-displayName"
      class="mb-4"
    >
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="model.displayName"
        required
        placeholder="Insira o nome do processo"
      >
      </b-form-input>
      <span class="text-danger" v-if="modelstate['DisplayName']">
        {{ modelstate["DisplayName"][0] }}
      </span>
    </b-form-group>

    <h4>{{ $t("workflow.processFields") }}</h4>

    <b-row>
      <b-col>
        <workflow-field :fields="model.fields" :modelstate="modelstate">
        </workflow-field>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <stage-crud :process="model" :stages="model.stages"> </stage-crud>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" md="3">
        <b-form-group
          :label="$t('workflow.permission.administrador')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="model.administrador"
            label="text"
            track-by="value"
            :close-on-select="false"
            :placeholder="$t('checklist.form.profilesViewer')"
            :showLabels="false"
            :multiple="true"
            :options="optionsProfiles"
          >
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="3">
        <b-form-group
          :label="$t('workflow.permission.gestor')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="model.gestor"
            label="text"
            track-by="value"
            :close-on-select="false"
            :placeholder="$t('checklist.form.profilesViewer')"
            :showLabels="false"
            :multiple="true"
            :options="optionsProfiles"
          >
          </multiselect>
        </b-form-group>
      </b-col>

      <b-col sm="12" md="3">
        <b-form-group
          :label="$t('workflow.permission.simpleOperator')"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <multiselect
            id="input-form-profile-fill"
            v-model="model.simpleOperator"
            label="text"
            track-by="value"
            :close-on-select="false"
            :showLabels="false"
            :placeholder="$t('workflow.permission.simpleOperator')"
            :multiple="true"
            :options="optionsProfiles"
          >
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" md="3">
        <div>
          <label for="select-see-just-own-processes">
            <b-row class="ml-auto">
              {{ $t("workflow.permission.seeJustOwnProcesses") }}
              <b-col>
                <b-icon
                  :title="$t('workflow.permission.seeJustOwnProcessesTooltip')"
                  v-b-tooltip.hover
                  icon="info-circle"
                ></b-icon>
              </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <multiselect
            id="select-see-just-own-processes"
            v-model="model.seeJustOwnProcesses"
            label="text"
            track-by="value"
            :placeholder="$t('workflow.permission.seeJustOwnProcesses')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="optionsProfiles"
          >
          </multiselect>
        </div>
      </b-col>

      <b-col sm="12" md="3">
        <div>
          <label for="select-see-just-own-processes">
            <b-row class="ml-auto">
              {{ $t("workflow.permission.seeJustSectorProcesses") }}
              <b-col>
                <b-icon
                  :title="
                    $t('workflow.permission.seeJustSectorProcessesTooltip')
                  "
                  v-b-tooltip.hover
                  icon="info-circle"
                ></b-icon>
              </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <multiselect
            id="select-see-just-own-processes"
            v-model="model.seeJustSectorProcesses"
            label="text"
            track-by="value"
            :placeholder="$t('workflow.permission.seeJustSectorProcesses')"
            :close-on-select="false"
            :showLabels="false"
            :multiple="true"
            :options="optionsProfiles"
          >
          </multiselect>
        </div>
      </b-col>
    </b-row>

    <div>
      <b-form-group
        label="Script pós processamento"
        label-for="ScriptPythonValidation"
      >
        <custom-codemirror
          id="ScriptPythonValidation"
          :model.sync="model.scriptPosProcess"
          :readonly="isMasterAdmin"
        />
      </b-form-group>
    </div>

    <!-- {{ isMasterAdmin }} -->
    <!-- {{ optionsProfiles }} -->
    <!-- {{ modelstate }} -->
    <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->
    <!-- <pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre> -->
  </div>
</template>
<script>
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";
export default {
  name: "ProcessCrud",
  props: {
    model: Object,
    modelstate: Object
  },
  components: {
    WorkflowField: () => import("@/components_rms/workflow/WorkflowField.vue"),
    StageCrud: () =>
      import("@/components_rms/workflow/StageCrud/StageCrud.vue"),
    CustomCodemirror
  },
  data() {
    return {
      isMasterAdmin: false,
      optionsProfiles: []
    };
  },
  created() {
    this.getUserMaster();
    this.loadOptionsProfiles();
  },
  methods: {
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then(response => {
          this.isMasterAdmin = response.data;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    loadOptionsProfiles() {
      this.$apiScheduler.get("/profile/getCompanyProfiles/").then(response => {
        response.data.forEach(x => {
          this.optionsProfiles.push({
            value: x.id,
            text: x.displayName
          });
        });
      });
    }
  }
};
</script>
